// extracted by mini-css-extract-plugin
module.exports = {"search":"inputDropdownMenu_search__Wm5L1"};